<template>
  <div class="template-center">
    <div class="breadcrumb">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>发现</el-breadcrumb-item>
        <el-breadcrumb-item>模板中心</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    
    <div class="filter-section">
      <div class="filter-wrap">
        <div class="filter-header">
          <el-radio-group v-model="activeCategory" size="mini">
            <el-radio-button label="all">全部</el-radio-button>
            <el-radio-button label="official">官方</el-radio-button>
            <el-radio-button label="collection">收藏</el-radio-button>
            <el-radio-button label="mine">我的</el-radio-button>
          </el-radio-group>
          
          <div class="filter-tools">
            <el-input
              placeholder="搜索模板"
              prefix-icon="el-icon-search"
              v-model="searchText"
              size="small"
              class="search-input"
            ></el-input>
            <el-button type="primary" size="small" plain icon="el-icon-plus">创建模板</el-button>
          </div>
        </div>
        
        <div class="filter-content">
          <div class="filter-item">
            <div class="filter-label">工作类型</div>
            <div class="filter-tags">
              <el-tag 
                v-for="tag in workTypes" 
                :key="tag.value"
                :effect="activeWorkType === tag.value ? 'dark' : 'plain'"
                @click="activeWorkType = tag.value"
                class="filter-tag"
                size="small"
              >
                {{ tag.label }}
              </el-tag>
            </div>
          </div>
          
          <div class="filter-item">
            <div class="filter-label">模板类型</div>
            <div class="filter-tags">
              <el-tag 
                v-for="tag in templateTypes" 
                :key="tag.value"
                :effect="activeTemplateType === tag.value ? 'dark' : 'plain'"
                @click="activeTemplateType = tag.value"
                class="filter-tag"
                size="small"
              >
                {{ tag.label }}
              </el-tag>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="template-list">
      <el-row :gutter="20">
        <el-col :span="6" v-for="(template, index) in filteredTemplates" :key="index">
          <el-card shadow="hover" class="template-card">
            <div class="template-header">
              <div class="template-icon">
                <i :class="template.icon"></i>
              </div>
              <div class="template-title">{{ template.title }}</div>
              <div class="template-operations">
                <i class="el-icon-star-off"></i>
              </div>
            </div>
            <div class="template-desc">{{ template.description }}</div>
            <div class="template-footer">
              <div class="template-tags">
                <el-tag size="mini" type="info">{{ template.type }}</el-tag>
                <el-tag size="mini" type="info">{{ template.workType }}</el-tag>
              </div>
              <div class="template-stats">
                <span><i class="el-icon-view"></i> {{ template.views }}</span>
                <span><i class="el-icon-star-on"></i> {{ template.stars }}</span>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    
    <div class="pagination-container">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="100"
        :page-size="20"
        :current-page="currentPage"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplateCenter',
  data() {
    return {
      activeCategory: 'all',
      searchText: '',
      activeWorkType: 'all',
      activeTemplateType: 'all',
      currentPage: 1,
      workTypes: [
        { label: '全部', value: 'all' },
        { label: '智能客服', value: 'customer-service' },
        { label: '生活帮手', value: 'life-assistant' },
        { label: '文本创作', value: 'text-creation' },
        { label: '图像处理', value: 'image-processing' },
        { label: '数据分析', value: 'data-analysis' },
        { label: '企业效率', value: 'enterprise-efficiency' }
      ],
      templateTypes: [
        { label: '全部', value: 'all' },
        { label: '知识应用', value: 'knowledge' },
        { label: '轻量应用', value: 'lightweight' },
        { label: '工作流', value: 'workflow' }
      ],
      templates: [
        {
          title: '智能客服',
          description: '基于企业知识库搭建智能客服应用',
          icon: 'el-icon-service',
          type: '知识应用',
          workType: '智能客服',
          views: 2356,
          stars: 324
        },
        {
          title: '手机号归属查询',
          description: '自定义插件使用——以「手机号归属地查询」插件的应用为例',
          icon: 'el-icon-mobile-phone',
          type: '轻量应用',
          workType: '生活帮手',
          views: 1856,
          stars: 256
        },
        {
          title: '心理咨询师',
          description: '有什么困惑，找牙医聊聊吧',
          icon: 'el-icon-chat-line-round',
          type: '轻量应用',
          workType: '生活帮手',
          views: 1560,
          stars: 198
        },
        {
          title: 'BMI指数计算',
          description: '输入身高和体重，帮你计算你的BMI（身体质量指数）指数并提供健康建议。',
          icon: 'el-icon-data-line',
          type: '轻量应用',
          workType: '生活帮手',
          views: 1421,
          stars: 187
        },
        {
          title: 'AI智能改图',
          description: '上传一张图片，使用自然语言描述对图片进行修改和绘画',
          icon: 'el-icon-picture',
          type: '轻量应用',
          workType: '图像处理',
          views: 2541,
          stars: 423
        },
        {
          title: '美食鉴赏家',
          description: '我可以帮你分析每餐饮的营养成分和饮食建议，请问想吃什么？',
          icon: 'el-icon-food',
          type: '轻量应用',
          workType: '生活帮手',
          views: 1354,
          stars: 176
        },
        {
          title: '数据库查询助手',
          description: '与数据库对话，智能分析数据，生成图表。',
          icon: 'el-icon-data-analysis',
          type: '知识应用',
          workType: '数据分析',
          views: 1987,
          stars: 302
        },
        {
          title: '服装销售',
          description: '线上服装推销和导购',
          icon: 'el-icon-shopping-bag-1',
          type: '知识应用',
          workType: '企业效率',
          views: 1253,
          stars: 165
        }
      ]
    };
  },
  computed: {
    filteredTemplates() {
      return this.templates.filter(template => {
        // 筛选工作类型
        const matchWorkType = this.activeWorkType === 'all' || template.workType === this.getWorkTypeLabel(this.activeWorkType);
        
        // 筛选模板类型
        const matchTemplateType = this.activeTemplateType === 'all' || template.type === this.getTemplateTypeLabel(this.activeTemplateType);
        
        // 搜索文本
        const matchSearch = this.searchText === '' || 
          template.title.toLowerCase().includes(this.searchText.toLowerCase()) || 
          template.description.toLowerCase().includes(this.searchText.toLowerCase());
        
        return matchWorkType && matchTemplateType && matchSearch;
      });
    }
  },
  methods: {
    handlePageChange(page) {
      this.currentPage = page;
      // 在实际应用中，这里应该请求后端获取分页数据
    },
    getWorkTypeLabel(value) {
      const found = this.workTypes.find(type => type.value === value);
      return found ? found.label : '';
    },
    getTemplateTypeLabel(value) {
      const found = this.templateTypes.find(type => type.value === value);
      return found ? found.label : '';
    }
  }
};
</script>

<style scoped>
.template-center {
  padding-bottom: 50px;
}

.breadcrumb {
  margin-bottom: 20px;
}

.filter-section {
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.filter-wrap {
  padding: 20px;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.filter-tools {
  display: flex;
  align-items: center;
}

.search-input {
  width: 200px;
  margin-right: 15px;
}

.filter-content {
  margin-top: 15px;
}

.filter-item {
  margin-bottom: 15px;
}

.filter-label {
  font-weight: 500;
  margin-bottom: 10px;
}

.filter-tags {
  display: flex;
  flex-wrap: wrap;
}

.filter-tag {
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}

.template-list {
  margin-bottom: 20px;
}

.template-card {
  height: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}

.template-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.template-icon {
  width: 40px;
  height: 40px;
  background-color: #f5f7fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #409EFF;
  margin-right: 10px;
}

.template-title {
  font-weight: 600;
  font-size: 16px;
  flex: 1;
}

.template-operations {
  color: #909399;
  cursor: pointer;
}

.template-desc {
  color: #606266;
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 15px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.template-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.template-tags {
  display: flex;
}

.template-tags .el-tag {
  margin-right: 5px;
}

.template-stats {
  font-size: 12px;
  color: #909399;
}

.template-stats span {
  margin-left: 10px;
}

.template-stats i {
  margin-right: 3px;
}

.pagination-container {
  text-align: center;
  margin-top: 30px;
}
</style> 